import { Typography, styled } from "@mui/material"

//Note difference: style={{ wordBreak: "break-all" }} vs. style={{ wordBreak: "break-word" }}
export const StyledWordBreak = styled(Typography)`
  color: inherit;
  word-break: break-word;
`

export default StyledWordBreak
